import { useTranslation } from 'react-i18next';
import { PageWrapper, PageTitle, PageDescription } from './style';
import { Button } from '@/components/UI/Button';
import { Box, Flex } from '@/layout';
import { useNavigate } from 'react-router-dom';
import useResize from '@/hooks/useResize';
import useCurrentLang from '@/hooks/useCurrentLang';

const Page404 = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const lang = useCurrentLang();
  const {isMobile} = useResize();
  const navigate = useNavigate();

  return (
    <PageWrapper isMobile={isMobile}>
      <PageTitle>
        {t('pages.404.title')}
      </PageTitle>
      <Flex flexDirection={'column'} alignItems={'center'} gridGap={'20px'}>
      <PageDescription>
        {t('pages.404.description-top')}
      </PageDescription>
      <PageDescription>
        {t('pages.404.description-bottom')}
      </PageDescription>
      </Flex>
      <Box marginTop={'80px'}>
        <Button
          size="md"
          variant="primary"
          onClick={() => navigate('/'+lang, { replace: true })}
          style={{ height: '50px' }}
        >
          {t('pages.404.backToHome')}
        </Button>
      </Box>
    </PageWrapper>
  );
};

export default Page404;
